import { SkeletonLoader } from 'components/SkeletonLoader/SkeletonLoader';
import { getValueByKey } from './utils';
import { CSSProperties } from 'react';

import './DataView.scss';

interface Cell {
  id: string;
  title?: string;
  defaultValue?: string;
  hidden?: boolean;
  style?: CSSProperties;
  renderValue?: () => JSX.Element;
  renderCell?: () => JSX.Element;
}

export type CellData = Record<string, string | number | undefined | null | object>;

interface IDataView {
  cells: Cell[];
  loading?: boolean;
  data: CellData;
  className?: string;
}

export const DataView = ({ cells, data, loading, className = '' }: IDataView) => {
  return (
    <div className={`dataView ${className}`}>
      {cells.map(({ id, title, defaultValue, renderValue, renderCell, hidden, style }, index) => {
        if (hidden) return null;

        const content = getValueByKey(id, data);

        const renderContent =
          typeof renderCell === 'function' ? (
            renderCell()
          ) : (
            <>
              <p className="infoLabel">{title}</p>
              {typeof renderValue === 'function' ? (
                renderValue()
              ) : (
                <p title={content} className="infoValue">
                  {content || defaultValue}
                </p>
              )}
            </>
          );

        const renderLoadingContent = (
          <div className="cellSkeleton">
            <SkeletonLoader height={10} width="50%" />
            <SkeletonLoader height={10} width="100%" />
          </div>
        );

        return (
          <div key={index} className={`infoCell`} style={style}>
            {loading ? renderLoadingContent : renderContent}
          </div>
        );
      })}
    </div>
  );
};
